module.exports = __webpack_public_path__ + "img/laboratorio_9-16_1080.47852802.jpg";